// extracted by mini-css-extract-plugin
module.exports = {"conatiner":"Loading_conatiner__1tMHT","loading_text":"Loading_loading_text__3yOn9","SuccessContainer":"Loading_SuccessContainer__3iJqM"};